import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "./locales/en/common.json";
import arCommon from "./locales/ar/common.json";
import arDeleteAccount from "./locales/ar/deleteAccount.json";
import enDeleteAccount from "./locales/en/deleteAccount.json";
import arSpeakerSummary from "./locales/ar/speakerSummary.json";
import enSpeakerSummary from "./locales/en/speakerSummary.json";
import arAuth from "./locales/ar/auth.json";
import enAuth from "./locales/en/auth.json";
import arpublications from "./locales/ar/publications.json";
import enpublications from "./locales/en/publications.json";
import arresetpassword from "./locales/ar/resetpassword.json";
import enresetpassword from "./locales/en/resetpassword.json";
import arprofile from "./locales/ar/profile.json";
import enprofile from './locales/en/profile.json';
import eninvoices from './locales/en/invoices.json';
import arinvoices from './locales/ar/invoices.json';
import arnetwork from './locales/ar/network.json';
import ennetwork from './locales/en/network.json';
import arletters from './locales/ar/letters.json';
import enletters from './locales/en/letters.json';
import ensubmissions from './locales/en/submissions.json';
import arsubmissions from './locales/ar/submissions.json';
import arPackages from './locales/ar/packages.json';
import enPackages from './locales/en/packages.json';
import enPurchases from "./locales/en/purchases.json";
import arPurchases from './locales/ar/purchases.json';
import ennewsubmission from "./locales/en/submissionWizard.json";
import arnewsubmission from "./locales/ar/submissionWizard.json"
import arSupport  from "./locales/ar/support.json";
import enSupport  from "./locales/en/support.json"
import enticketDetail from "./locales/en/ticketDetail.json"
import articketDetail from "./locales/ar/ticketDetail.json"

const LANGUAGE_STORAGE_KEY = "esc_portal_lang";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enCommon, 
        common: enCommon,
        deleteAccount: enDeleteAccount,
        speakerSummary: enSpeakerSummary,
        auth: enAuth,
        publications: enpublications,
        resetpassword: enresetpassword,
        profile: enprofile,
        invoices: eninvoices,
        network: ennetwork,
        letters: enletters,
        submissions: ensubmissions,
        packages: enPackages,
        purchases: enPurchases,
        submissionWizard: ennewsubmission,
        support: enSupport,
        ticketDetail: enticketDetail, // ✅ موجود
      },
      ar: {
        translation: arCommon, 
        common: arCommon,
        deleteAccount: arDeleteAccount, 
        speakerSummary: arSpeakerSummary,
        auth: arAuth,
        publications: arpublications,
        resetpassword: arresetpassword,
        profile: arprofile,
        invoices: arinvoices,
        network: arnetwork,
        letters: arletters,
        submissions: arsubmissions,
        packages: arPackages,
        purchases: arPurchases,
        submissionWizard: arnewsubmission,
        support: arSupport,
        ticketDetail: articketDetail, // ✅ موجود
      },
    },
    // ✅ أضف ns هنا!
    ns: [
      'translation',
      'common',
      'deleteAccount',
      'speakerSummary',
      'auth',
      'publications',
      'resetpassword',
      'profile',
      'invoices',
      'network',
      'letters',
      'submissions',
      'packages',
      'purchases',
      'submissionWizard',
      'support',
      'ticketDetail' // ✅ أضف هذا
    ],
    defaultNS: 'translation',
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

// دالة مساعدة لتغيير اللغة مع تخزينها
export const switchLanguage = (lang) => {
  i18n.changeLanguage(lang);
  localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = lang;
  document.body.classList.remove("rtl", "ltr");
  document.body.classList.add(lang === "ar" ? "rtl" : "ltr");
};

// استعادة اللغة والاتجاه عند تحميل الصفحة
const savedLang =
  localStorage.getItem(LANGUAGE_STORAGE_KEY) || i18n.language || "en";
document.documentElement.dir = savedLang === "ar" ? "rtl" : "ltr";
document.documentElement.lang = savedLang;
document.body.classList.add(savedLang === "ar" ? "rtl" : "ltr");

export default i18n;